var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.checkPermission(["chartView_student_status_and_attendance"])
    ? _c("div", { staticClass: "card-wrapper" }, [
        _c("div", { staticClass: "card-top" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "card-heading" }, [
              _vm._m(0),
              _c("div", [
                _c("p", { staticClass: "card-title" }, [
                  _vm._v("Trạng thái học sinh"),
                ]),
                _c("p", { staticClass: "card-subtitle" }, [
                  _vm._v("Tổng quan phân HS theo trạng thái hiện tại"),
                ]),
                _c("div", { staticClass: "header-tags" }, [
                  _c("span", { staticClass: "header-tag" }, [
                    _vm._v("Tổng " + _vm._s(_vm.totalStudents) + " học sinh"),
                  ]),
                  _c("span", { staticClass: "header-tag header-tag--soft" }, [
                    _vm._v("Nổi bật: " + _vm._s(_vm.leadingStatusLabel)),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm.loaded && _vm.summaryCards.length
            ? _c(
                "div",
                { staticClass: "summary-row" },
                _vm._l(_vm.summaryCards, function (summary) {
                  return _c(
                    "div",
                    {
                      key: summary.label,
                      staticClass: "summary-card",
                      style: { "--summary-accent": summary.color },
                    },
                    [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v(_vm._s(summary.label)),
                      ]),
                      _c("strong", { staticClass: "summary-value" }, [
                        _vm._v(_vm._s(summary.value)),
                      ]),
                      _c("span", { staticClass: "summary-percent" }, [
                        _vm._v(_vm._s(summary.percent) + "%"),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "chart-shell" }, [
          _vm.isLoading
            ? _c("div", { staticClass: "chart-content" }, [_vm._m(1)])
            : _vm.loaded && _vm.hasData
            ? _c("div", { staticClass: "chart-content" }, [
                _c("div", { staticClass: "chart-layout" }, [
                  _c(
                    "div",
                    { staticClass: "chartPie" },
                    [
                      _c("ChartPie", {
                        attrs: {
                          chartData: _vm.dataConnection.chartData,
                          options: _vm.dataConnection.options,
                          checkLable: true,
                          height: 300,
                        },
                      }),
                      _c("div", { staticClass: "donut-center-text" }, [
                        _c("p", { staticClass: "center-value" }, [
                          _vm._v(_vm._s(_vm.totalStudents)),
                        ]),
                        _c("p", { staticClass: "center-label" }, [
                          _vm._v("Học sinh"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ])
            : _c("div", { staticClass: "chart-content chart-empty" }, [
                _vm._m(2),
              ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-icon" }, [
      _c("i", { staticClass: "el-icon-user-solid" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state-card state-card--loading" }, [
      _c("i", { staticClass: "el-icon-loading state-icon" }),
      _c("div", [
        _c("p", { staticClass: "state-title" }, [
          _vm._v("Đang tải dữ liệu biểu đồ"),
        ]),
        _c("span", { staticClass: "state-text" }, [
          _vm._v(
            "Hệ thống đang cập nhật phân bổ trạng thái học sinh mới nhất."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state-card state-card--empty" }, [
      _c("i", { staticClass: "el-icon-data-analysis state-icon" }),
      _c("div", [
        _c("p", { staticClass: "state-title" }, [
          _vm._v("Chưa có dữ liệu trạng thái học sinh"),
        ]),
        _c("span", { staticClass: "state-text" }, [
          _vm._v(
            "Khi có dữ liệu, biểu đồ donut và tỷ trọng từng trạng thái sẽ hiển thị tại đây."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }